import HeaderWithBackButton from 'app/components/HeaderWithBackButton';
import Dropdown from 'app/components/Dropdown';
import NewInput from 'app/components/NewInput';
import PageLoader from 'app/components/PageLoader';
import NumberInput from 'app/components/UI/NumberInput';
import Button from 'app/components/button';
import Toggle from 'react-toggle';
import NewAttachment from 'app/components/NewAttachment';
import TextArea from 'app/components/Textarea';
import TimePickerComponent from 'app/components/TimePicker';
import { APP_CONSTANTS } from 'app/constants/app-constants';
import useCreateEvent from './useCreateEvent';
import { commonMaxDate, commonMinDate } from 'app/utils/Parsers';

const CreateEvent = () => {
  const {
    eventId,
    mallList,
    handleChange,
    values,
    error,
    handleCreateEvent,
    pageLoading,
    hideFields,
    uploadMediaHandler,
    setChange,
    navigate,
    handleTime,
  } = useCreateEvent();

  return (
    <div className='blogsForm'>
      <div className='blogsForm_content'>
        <HeaderWithBackButton
          title={` ${eventId ? ' Edit Event  ' : 'Create Event'}`}
          goTo={APP_CONSTANTS.EVENT}
        />
        <div className='inner-form-wrapper flex justify-between flex-wrap mb-4'>
          <div className='wd-50'>
            <NewInput
              label='Event Name*'
              id='name'
              type='text'
              placeholder='Event Name'
              name='name'
              value={values?.name}
              onChange={handleChange}
              errorText={error?.name}
            />
          </div>
          <div className='wd-50'>
            <Dropdown
              id={'mall_Id'}
              label='Mall name*'
              name='mall_Id'
              options={mallList}
              placeholder='Select Mall '
              value={values?.mall_Id}
              handleChange={handleChange}
              isFieldHidden={hideFields}
              errorText={error?.mall_Id}
            />
          </div>
          <div className='wd-100'>
            <NewInput
              label='Headline*'
              id='headline'
              type='text'
              placeholder='Headline'
              name='headline'
              value={values?.headline}
              onChange={handleChange}
              errorText={error?.headline}
            />
          </div>
          <div className='wd-50'>
            <NewInput
              label='Primary URL'
              id='url'
              type='text'
              placeholder='Primary URL'
              name='url'
              value={values?.url}
              onChange={handleChange}
              errorText={error?.url}
              isFieldHidden={hideFields}
            />
          </div>
          <div className='wd-50'>
            <NewInput
              label='Secondary URL'
              id='secondaryUrl'
              type='text'
              placeholder='Secondary URL'
              name='secondaryUrl'
              value={values?.secondaryUrl ?? ''}
              onChange={handleChange}
              errorText={error?.secondaryUrl}
              isFieldHidden={hideFields}
            />
          </div>
          <div className='wd-50'>
            <label> Cover Image* </label>
            <NewAttachment
              value={values?.coverImage}
              id='coverImage'
              onFileSelected={uploadMediaHandler}
              fileType='image'
              label='Choose File'
              className='feed_attachment'
              alt='coverImage'
              errorText={error?.coverImage}
              dimesnsionLabel='(375*230)'
            />
          </div>
          <div className='wd-50'>
            <label> Additional Image </label>
            <NewAttachment
              value={values?.additionalImage}
              id='additionalImage'
              onFileSelected={uploadMediaHandler}
              fileType='image'
              label='Choose File'
              className='feed_attachment'
              errorText={error?.additionalImage}
              dimesnsionLabel='(130*110)'
            />
          </div>
          <div className='wd-100'>
            <TextArea
              label='Description*'
              id='description'
              type='text'
              placeholder='Description'
              name='description'
              value={values?.description}
              onChange={handleChange}
              errorText={error?.description}
            />
          </div>
          <div className='wd-50'>
            <NewInput
              label='Location details*'
              id='locationDetails'
              type='text'
              placeholder='Location'
              name='locationDetails'
              value={values?.locationDetails}
              onChange={handleChange}
              errorText={error?.locationDetails}
              isFieldHidden={hideFields}
            />
          </div>
          <div className='wd-50'>
            <NumberInput
              label='Contact details*'
              id='phone'
              placeholder='Contact Number'
              name='phone'
              value={values.phone}
              errorText={error?.phone}
              onChange={handleChange}
            />
          </div>

          <div className='wd-50'>
            <NewInput
              label='Start Date*'
              id='startDate'
              placeholder='DD-YY-MMMM'
              name='startDate'
              format='DD-MM-YYYY'
              type={'date'}
              // min={commonMinDate()}
              max={commonMaxDate()}
              value={values?.startDate}
              onChange={handleChange}
              errorText={error?.startDate}
            />
          </div>
          <div className='wd-50'>
            <NewInput
              label='End Date*'
              name='endDate'
              id='endDate'
              placeholder={'End Date'}
              min={values.startDate ? values.startDate : commonMinDate()}
              max={commonMaxDate()}
              value={values?.endDate}
              type={'date'}
              onChange={handleChange}
              errorText={error?.endDate}
            />
          </div>
          <div className='wd-100'>
            <label className='tooltip-on-hover'>Timing*</label>
            <div className='date-picker-wrapper flex gap-10'>
              <TimePickerComponent
                initialTime={values?.eventOpeningTime}
                onTimeChange={(value) => handleTime(value, 'eventOpeningTime')}
                // errorText={error?.eventOpeningTime}
              />

              <TimePickerComponent
                initialTime={values?.eventClosingTime}
                onTimeChange={(value) => handleTime(value, 'eventClosingTime')}
                //  errorText={error?.eventClosingTime}
              />
            </div>
            <div className='wd-100 d-flex'>
              {error?.eventOpeningTime && (
                <p className='loginWrapper-valid-text margin-right-class'>
                  {error?.eventOpeningTime}
                </p>
              )}
              {error?.eventClosingTime && (
                <p className='loginWrapper-valid-text'>
                  {error?.eventClosingTime}
                </p>
              )}
            </div>
          </div>

          <div className='d-block wd-100'>
            <label className='me-2 d-inline-block tooltip-on-hover'>
              Status*
            </label>
            <label className='d-inline-block mt-2'>
              <div className='d-inline-flex align-items-center'>
                <div className='d-inline-flex text-danger'>OFF</div>
                <div className='d-inline-flex mx-2'>
                  <Toggle
                    checked={values.status}
                    icons={false}
                    onChange={() => setChange('status', !values.status)}
                  />
                </div>
                <div className='d-inline-flex text-green'>ON</div>
              </div>
            </label>
            </div>
            <div className='d-block wd-100'>
            <label className='me-2 d-inline-block tooltip-on-hover'>
              Publish
            </label>
            <label className='d-inline-block mt-2'>
              <div className='d-inline-flex align-items-center'>
                <div className='d-inline-flex text-danger'>OFF</div>
                <div className='d-inline-flex mx-2'>
                  <Toggle
                    checked={values.publish}
                    icons={false}
                    onChange={() => setChange('publish', !values.publish)}
                  />
                </div>
                <div className='d-inline-flex text-green'>ON</div>
              </div>
            </label>
          </div>
        </div>
        <div className='d-flex justify-content-start'>
          <Button
            className='mt1'
            onClick={handleCreateEvent}
            variant='Save'
            name='Submit'
            isDisabled={pageLoading ? true : false}
          />
          <Button
            className='mt1 cancel-button ms-2'
            onClick={() => navigate(-1)}
            variant='Cancel'
            name='Cancel'
            isDisabled={pageLoading ? true : false}
          />
        </div>
      </div>
      {pageLoading && <PageLoader pageLoading={pageLoading} />}
    </div>
  );
};

export default CreateEvent;
